import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, Page, PageParameters } from '@elotech/angular-common';
import { MovimentacaoPessoalService } from './movimentacao-pessoal.service';
import { map } from 'rxjs/operators';
import {
  MovimentacaoAfastamentoFichaFinanceira
} from "../funcionario/detail/fucionario-detail/movimentacao-afastamento-ficha-financeira";

const RESOURCE = '/api/afastamentos';

@Injectable()
export class MovimentacaoAfastamentoService extends MovimentacaoPessoalService {

  constructor(public httpClient: HttpClient) {
    super(httpClient);
  }

  public loadFieldModels(): Observable<any> {
    return this.httpClient.get({resource: `${RESOURCE}/model`});
  }

  findAll(page?: PageParameters, search?: string, fields?: string, disableSpinner?: boolean): Observable<Page<any>> {
    return this.httpClient.get({
      resource: RESOURCE,
      page: page,
      search: this.buildSearch(search),
      disableSpinner: disableSpinner,
      fields: this.calculeFields('movimentacao.id,movimentacao.funcionario.pessoa.id,afastamento.tipoMovimentacao.id,' + fields),
      location: this.location
    });
  }

  public loadDashboardAfastamentos(competencia: any): Observable<any> {
    return this.httpClient.post({
      resource: `${RESOURCE}/dashboard`,
      body: competencia,
      disableSpinner: true
    });
  }

  public print(filter: string, fields: string, page: PageParameters): Observable<string> {
    return this.httpClient.get({
      resource: `${RESOURCE}/report?${page.toUrlParameters()}`,
      responseType: 'text',
      fields: fields,
      search: this.buildSearch(filter),
      location: this.location
    }).pipe(map(html => {
      return URL.createObjectURL(new Blob([html], {type: 'text/html'}));
    }));
  }

  public removerMovimentacao(id: number) {
    return this.httpClient.del({
      resource: `${RESOURCE}/remove/${id}`,
    });
  }

  findAllByFuncionarioId(funcionarioId: number, page?: PageParameters, search?: string, fields?: string, disableSpinner?: boolean): Observable<Page<any>> {
    return this.httpClient.get({
      resource: `${RESOURCE}/por-funcionario/${funcionarioId}`,
      page: page,
      search: this.buildSearch(search),
      disableSpinner: disableSpinner
    });
  }

  public findByMovimentacaoFuncionarioAndCompetencia(funcionarioId: number, disableSpinner: boolean = true): Observable<MovimentacaoAfastamentoFichaFinanceira> {
    return this.httpClient.get({
      resource: `${RESOURCE}/by-funcionario-and-competencia/${funcionarioId}`,
      disableSpinner: disableSpinner
    });
  }

  objToOption(item: any): string {
    if (item?.afastamento?.codigo) {
      return `${item.afastamento.codigo} - ${item.afastamento.descricao}`;
    }
    return '';
  }

}
